import { useEffect, useState } from "react";
import ProductCardDesktop from "./ProductCardDesktop";
import ProductCardMobile from "./ProductCardMobile";

const ProductCard = (props) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1100);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1100);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile ? <ProductCardMobile {...props} /> : <ProductCardDesktop {...props} />;
};

export default ProductCard;

